/* eslint-disable max-len */
// FIXME: remove eslint disable when done
/* eslint-disable */
import {
  getCategoryMaster,
  getCountOfEstate,
  getRailwayCorporation,
  getRailwayCorporationDB,
  getTrainLineCorporation,
  listLicenseNumberFirst,
  getListPrefectures,
  getYearJapan,
  getCities,
  getDistricts,
  getPermission,
  checkMaintenance,
  subscribeTokenFirebase,
  unSubscribeTokenFirebase,
} from '@/apis/common';
import { STATION_TYPE } from '@/constants/common';
import {
  ESTATE_CATEGORY_ID,
  STRUCTURE_CATEGORY_ID,
  BUILDING_MAP_CATEGORY_ID,
  LAND_OWNERSHIP_CATEGORY_ID,
  SITUATION_CATEGORY_ID,
  TYPE_OF_LAND_CATEGORY_ID,
  USE_OF_AREA_CATEGORY_ID,
  DISTRICT_CATEGORY_ID,
  RENTAL_MANAGEMENT_METHOD_CATEGORY_ID,
  PREFECTURE_CATEGORY_ID,
  TRAIN_LINE_1,
  TRAIN_LINE_2,
  TRAIN_LINE_3,
  ESTATE_CATEGORIES,
} from '@/constants/estate';
import { COMMONS } from '../mutation-types';

export const state = {
  estateCategories: [],
  railwayCorporations: [],
  trainLineCorporations: [],
  countOfEstates: [],
  station1: [],
  station2: [],
  station3: [],
  priceFromOptions: [],
  priceToOptions: [],
  showSideMenu: false,
  isMobile: false,
  listLicenseNumberFirst: [],
  prefectures: [],
  yearJapan: [],
  cityList: {},
  districtList: {},
  isLoading: false,
};

export const getters = {
  categoryMaster: (state) => state.estateCategories,
  estateCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORY_ID),
  structureCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === STRUCTURE_CATEGORY_ID),
  buildingMapCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === BUILDING_MAP_CATEGORY_ID),
  landOwnershipCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === LAND_OWNERSHIP_CATEGORY_ID),
  situationCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === SITUATION_CATEGORY_ID),
  typeOfLandCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === TYPE_OF_LAND_CATEGORY_ID),
  useOfAreaCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === USE_OF_AREA_CATEGORY_ID),
  districtCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === DISTRICT_CATEGORY_ID),
  rentalManagementCategories: (state) =>
    state.estateCategories.filter(
      (obj) => obj.category_id === RENTAL_MANAGEMENT_METHOD_CATEGORY_ID,
    ),
  prefectureCategories: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === PREFECTURE_CATEGORY_ID),

  // S0001
  priceFromOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.PRICE_FROM),

  // S0002
  priceToOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.PRICE_TO),

  // S0003
  timeFromStationOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.TIME_FROM_STATION),

  // S0004
  timeToStationOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.TIME_TO_STATION),

  // S0007
  constructAreaFromOptions: (state) =>
    state.estateCategories.filter(
      (obj) => obj.category_id === ESTATE_CATEGORIES.CONSTRUCT_AREA_FROM,
    ),

  // S0008
  constructAreaToOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.CONSTRUCT_AREA_TO),

  // S0009
  constructDateFromOptions: (state) =>
    state.estateCategories.filter(
      (obj) => obj.category_id === ESTATE_CATEGORIES.CONSTRUCT_DATE_FROM,
    ),

  // S00010
  constructDateToOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.CONSTRUCT_DATE_TO),

  // S00011
  totalFlatFromOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.TOTAL_FLAT_FROM),

  // S00012
  totalFlatToOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.TOTAL_FLAT_TO),

  // E0001
  typeOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.TYPE),

  // E0002
  structureOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.STRUCTURE),

  // E0003
  buildingMapOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.BUILDING_MAP),

  // E0004
  landOwnershipOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.LAND_OWNERSHIP),

  // E0005
  situationOptions: (state) =>
    state.estateCategories.filter((obj) => obj.category_id === ESTATE_CATEGORIES.SITUATION),

  railwayCorporations: (state) => state.railwayCorporations,
  trainLineCorporations: (state) => state.trainLineCorporations,
  countOfEstates: (state) => state.countOfEstates,
  station1: (state) => state.station1,
  station2: (state) => state.station2,
  station3: (state) => state.station3,
  showSideMenu: (state) => state.showSideMenu,
  isMobile: (state) => state.isMobile,
  listLicenseNumberFirst: (state) => state.listLicenseNumberFirst,
  listPrefectures: (state) => {
    state.prefectures = state.prefectures.map((obj) => obj.code_name);

    return state.prefectures;
  },
  yearJapan: (state) => state.yearJapan,
  cityList: (state) => state.cityList,
  districtList: (state) => state.districtList,
  isLoading: (state) => state.isLoading,
};

export const mutations = {
  [COMMONS.GET_CATEGORY_MASTER](state, data) {
    if (!data.error) {
      state.estateCategories = data;
    }
  },
  [COMMONS.GET_RAILWAY_CORPORATION](state, data) {
    if (!data.error) {
      state.railwayCorporations = data.filter((v) => v.Type === STATION_TYPE);
    }
  },
  [COMMONS.GET_TRAIN_LINE_CORPORATION](state, data) {
    if (!data.error) {
      state.trainLineCorporations = data;
    }
  },
  [COMMONS.GET_COUNT_OF_ESTATE](state, {
    res,
    trainLineStt,
  }) {
    if (!res.error) {
      switch (trainLineStt) {
        case TRAIN_LINE_1:
          state.station1 = res;
          break;
        case TRAIN_LINE_2:
          state.station2 = res;
          break;
        case TRAIN_LINE_3:
          state.station3 = res;
          break;
        default:
          break;
      }
    }
  },
  [COMMONS.SET_SHOW_SIDE_MENU](state, payload) {
    state.showSideMenu = payload;
  },
  [COMMONS.SET_IS_MOBILE](state, payload) {
    state.isMobile = payload;
  },
  [COMMONS.GET_LICENSE_NUMBER_FIRST](state, data) {
    if (!data.error) {
      state.listLicenseNumberFirst = data;
    }
  },
  [COMMONS.GET_LIST_PREFECTURES](state, data) {
    if (!data.error) {
      state.prefectures = data.prefectures;
    }
  },
  [COMMONS.GET_YEAR_JAPAN](state, data) {
    if (!data.error) {
      state.yearJapan = data.japaneseCalendar;
    }
  },
  [COMMONS.SET_CITIES](state, data) {
    if (!data.error) {
      state.cityList = data;
    }
  },
  [COMMONS.SET_DISTRICTS](state, data) {
    if (!data.error) {
      state.districtList = data;
    }
  },
  [COMMONS.SET_IS_LOADING](state, data) {
    state.isLoading = data;
  },
};

export const actions = {
  async getCategoryMaster({ commit }) {
    const res = await getCategoryMaster();
    commit(COMMONS.GET_CATEGORY_MASTER, res);
  },
  async getRailwayCorporation({ commit }, params) {
    const res = await getRailwayCorporation(params);
    commit(COMMONS.GET_RAILWAY_CORPORATION, res);
  },
  async getRailwayCorporationDB({ commit }, params) {
    const res = await getRailwayCorporationDB(params);
    commit(COMMONS.GET_RAILWAY_CORPORATION, res);
  },
  async getTrainLineCorporation({ commit }, params) {
    const res = await getTrainLineCorporation(params);
    commit(COMMONS.GET_TRAIN_LINE_CORPORATION, res);
  },
  async getCountOfEstate({ commit }, data) {
    const res = await getCountOfEstate(data.params);
    commit(COMMONS.GET_COUNT_OF_ESTATE, {
      res,
      trainLineStt: data.trainLineStt,
    });
  },
  async listLicenseNumberFirst({ commit }) {
    const res = await listLicenseNumberFirst();
    commit(COMMONS.GET_LICENSE_NUMBER_FIRST, res);
  },
  async getListPrefectures({ commit }) {
    const res = await getListPrefectures();
    commit(COMMONS.GET_LIST_PREFECTURES, res);
  },
  async getYearJapan({ commit }) {
    const res = await getYearJapan();
    commit(COMMONS.GET_YEAR_JAPAN, res);
  },
  async getCities({ commit }, params) {
    const res = await getCities(params);
    commit(COMMONS.SET_CITIES, res);
    return res;
  },
  async getDistricts({ commit }, params) {
    const res = await getDistricts(params);
    commit(COMMONS.SET_DISTRICTS, res);
    return res;
  },
  async getPermission({ commit }) {
    const res = await getPermission();
    return res;
  },
  async actCheckMaintenance(_) {
    return await checkMaintenance();
  },
  getIsLoading({ commit }, data) {
    commit(COMMONS.SET_IS_LOADING, data);
  },
  async subscribeTokenFirebase({ commit }, data) {
    return await subscribeTokenFirebase(data);
  },
  async unSubscribeTokenFirebase({ commit }, data) {
    return await unSubscribeTokenFirebase(data);
  },
};
